import styles from './DataDownload.module.css';
import { Select } from '@round/ui-kit';
import { StylesConfig, ValueType } from 'react-select';
import { GenericDropdownOption } from '../../../../App.types';
import InfluencerReportDownload from './InfluencerReportDownload/InfluencerReportDownload';
import HashtagReportDownload from './HashtagReportDownload/HashtagReportDownload';
import useUrlState from '../../../../Hooks/useUrlState';

type DownloadOptions = 'influencer_report_download' | 'hashtag_report_download';

const downloadOptions: GenericDropdownOption<DownloadOptions>[] = [
    { value: 'influencer_report_download', label: 'Influencer Report' },
    { value: 'hashtag_report_download', label: 'Hashtag Report' },
];

type UrlState = {
    report: DownloadOptions;
};

type DownloadOptionsMap = {
    [key in DownloadOptions]: React.ReactElement;
};

const downloadOptionsMap: DownloadOptionsMap = {
    influencer_report_download: <InfluencerReportDownload />,
    hashtag_report_download: <HashtagReportDownload />,
};

const selectStyles: StylesConfig = {
    control: (provided) => ({
        ...provided,
        fontWeight: 500,
        minWidth: '15rem',
        maxWidth: '22.5rem',
    }),
};

const DataDownload = () => {
    const [urlState, setUrlState] = useUrlState<UrlState>({
        report: downloadOptions[0]?.value,
    });

    const selectedOption = downloadOptions.find((option) => option.value === urlState.report) ?? downloadOptions[0];
    const setSelectedOption = (option: ValueType<GenericDropdownOption<DownloadOptions>, false>) => {
        setUrlState({ report: option?.value }, { replace: true });
    };

    const selectedComponent = selectedOption?.value ? downloadOptionsMap[selectedOption.value] : null;

    return (
        <main className={styles.container}>
            <div className={styles.header}>
                <h1 className={styles.title}>{`Data Download - ${selectedOption.label}`}</h1>
                <Select
                    options={downloadOptions}
                    value={selectedOption}
                    onChange={setSelectedOption}
                    styles={selectStyles}
                    placeholder="Select download type..."
                    menuPortalTarget={document.body}
                />
            </div>
            <article>{selectedComponent}</article>
        </main>
    );
};

export default DataDownload;
